/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Save_ErrorInputs */

const en_admin_settings_save_error = /** @type {(inputs: Admin_Settings_Save_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to save`)
};

const zh_admin_settings_save_error = /** @type {(inputs: Admin_Settings_Save_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存失败`)
};

/**
* | output |
* | --- |
* | "Failed to save" |
*
* @param {Admin_Settings_Save_ErrorInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_settings_save_error = /** @type {((inputs?: Admin_Settings_Save_ErrorInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Save_ErrorInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_settings_save_error(inputs)
	return zh_admin_settings_save_error(inputs)
});
export { admin_settings_save_error as "admin.settings.save_error" }